// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_st-0";
export var checkoutRateBadgeLink = "_st-1";